export default {"link":"_9xx9K","iconContainer":"O2Wsy","linkIcon":"V87P6","linkText":"mGmQO","arrow":"_29Ndc"};